import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=f7433c44&scoped=true"
import script from "./NewCompany.vue?vue&type=script&lang=js"
export * from "./NewCompany.vue?vue&type=script&lang=js"
import style0 from "./NewCompany.vue?vue&type=style&index=0&id=f7433c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7433c44",
  null
  
)

export default component.exports